import React from 'react'
import { Container } from 'react-bootstrap'
import { useTheme } from '@config/themeContext'

const Footer = () => {
  const { theme } = useTheme()
  return (
    <footer
      className={`footer bg-${theme} text-${
        theme === 'dark' ? 'light' : 'dark'
      }`}
    >
      <Container></Container>
    </footer>
  )
}

export default Footer
